$(document).ready(function () {
  
  var delay = 0; // Height of header
  var lastScrollTop = 0;

  handleScroll();

  function handleScroll() {
    var st = $(this).scrollTop();
    if (st > lastScrollTop && st > delay) {
      $("header").addClass("translated");
    } else {
      $("header").removeClass("translated");
    }

     if (st < 100) {
      $("header").addClass("top");
    } else {
      $("header").removeClass("top");
    }

    lastScrollTop = st;
  }

  $(window).scroll(function (event) {
    handleScroll();
  });

  
  etxScrollClass(window, $('header'), $('body'), 60, 'top', 'up');


  if ($('.announcement-bar-section').length > 0) {
    etxScrollClass(window, $('.announcement-bar-section'), $('body'), 60, 'top', 'up'); 
  }
  
  
  if (typeof etxLazyLoad === 'function') etxLazyLoad();
  
  // HEADER NAVIGATION TOGGLE

  position_top = 0;

  $(".HeaderNavToggle").click(function (e) {
	  
    if ($("html").hasClass("nav-show")) {
      $("html").removeClass("nav-show");

      // RESET SUBNAV

      //$(document).scrollTop(position_top);
    } else {
      //position_top = $(document).scrollTop();

      $("html").addClass("nav-show");

      $(".HeaderExpandable__inner").hide();

      $(".HeaderExpandable__topnav").show();
    }
  });

  $(".HeaderExpandableOverview__back").on("click", function () {
    $(".HeaderExpandable__inner").hide();

    $(".HeaderExpandable__topnav").show(); 
  });
  
  
  
  // HEADER NAV

  $(".HeaderExpandable__inner").hide();

  $(".HeaderNav").find("a, span").on("click", function () {
      
    currentNav = $(this).data("nav-expandable");

    if ($(this).hasClass("active")) {
      $(this).removeClass("active");

      $("html").removeClass("nav-show");

      $(".HeaderExpandable__inner").hide();
    
    } else {
    
      $(".HeaderNav").find("a,span").removeClass("active");

      $(".HeaderExpandable__inner").hide();

      $(this).addClass("active");

      $("html").addClass("nav-show");

      $('.HeaderExpandable__inner[data-nav-expandable-content="' + currentNav + '"]').show();
    
    }
    
  });

  $(".HeaderExpandable__topnav").find("a, span").on("click", function () {
	  
    currentNav = $(this).data("nav-expandable");

    $(".HeaderNav").find("a,span").removeClass("active");

    $(".HeaderExpandable__inner").hide();

    $(this).addClass("active");

    $("html").addClass("nav-show");

    $('.HeaderExpandable__inner[data-nav-expandable-content="' + currentNav + '"]').show();
    
  });
  
  

  // HEADER LANGUAGE

  $(".HeaderLanguage__button").on("click", function () {
    $(this).closest(".HeaderLanguage").toggleClass("active");
  });

  $(".HeaderLanguage").find(".lang_switcher_link").each(function () {
	  
    var currentText = $(this).text().split(" ");

    $(this).text(currentText[0]);
    
  });


 

  // HERO AS FIRST ELEMENT
	
  let heroIndex = 0;
  
  $('html').find('main').find('.shopify-section').each( function() {

      // console.log(heroIndex + ' ' + $(this).prop('id'));
    
      if (heroIndex == 0 && ($(this).prop('id').indexOf('hero_home') != -1 || $(this).prop('id').indexOf('hero_full') != -1)) {
          $('body').addClass('has-hero');
      }
      
      heroIndex++;
      
  });
	

    addAnnouncementBarSpacing();
    
    document.addEventListener('click', (event) => {
      if (event.target.closest('.jm-verified-badge')) {
        console.log("CLICKED");
      }
    });
  
});


function addAnnouncementBarSpacing() {
  if($(".announcement-bar-section").length) {
    const announcementBar = $(".announcement-bar-section:eq(0)");
    $("body:not(:has(.Hero__Fullscreen)):not(:has(.Hero__Home)").css("margin-top", `${announcementBar.outerHeight()}px`);
  }
}


$(window).on("resize", function () {
    addAnnouncementBarSpacing();
});

// CLOSE NAVI IF OPENED AND CLICK OUTSIDE
$(document).click(function(event) { 
    var $target = $(event.target);
    if(!$target.closest('header').length && 
      $('html').hasClass("nav-show")) {
      $(".HeaderNav ul li span.active").removeClass("active");
      $("html").removeClass("nav-show");
      $(".HeaderExpandable__inner").hide();
    }   
});